// src/pages/cuentas-bancarias/index.js
import CuentasBancarias from './CuentasBancarias'

export default CuentasBancarias
